import { createFileRoute } from '@tanstack/react-router';

import { EntryLogPage } from '@/features/entry-log/EntryLogPage';

export const Route = createFileRoute('/admin/entry-log')({
  component: EntryLogPage,
});
